import { handleActions } from 'redux-actions'
import get from 'lodash.get'

import {
  setDownloadsDataAction,
} from '../actions/downloads'

const INITIAL_STATE = {
  loading: false, data: null, error: ''
}

const reducer = handleActions({
  [setDownloadsDataAction]: (state, action) =>
  ({
    error: '',
    loading: false,
    list: get(action, 'payload', [])
  })
}, INITIAL_STATE)

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/downloads.js